import React from 'react';
import styled from 'styled-components';

export const SummaryMetricContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;
export const SummaryMetricValue = styled.div`
  font-size: 32px;
  line-height: 100%;
  display: flex;
  align-items: center;
  white-space: nowrap;
  padding: 6px 0px 0px 5px;
  font-weight: 300;
`;
export const SummaryMetricLabel = styled.div`
  font-size: 13px;
  text-transform: uppercase;
  max-width: 50px;
  line-height: 100%;
  display: flex;
  align-items: center;
  padding: 8px 5px 5px 0;
`;

export function SummaryMetric({ value, label }) {
  return (
    <SummaryMetricContainer>
      <SummaryMetricValue>{value}</SummaryMetricValue>
      <SummaryMetricLabel>{label}</SummaryMetricLabel>
    </SummaryMetricContainer>
  );
}
